<wlm-dynamic-layout
  *ngIf="dynamicLayoutSettings"
  [settings]="dynamicLayoutSettings"
></wlm-dynamic-layout>
